const url = 'https://krikos360.planexware.net';

export const environment = {
  production: true,
  url,
  apiUrl: url + '/api2',
  mbeUrl: url + '/api2',
  mfeUrl: url + '/mfes',
  gaTrackId:'G-C5HHD78KEH',
  googleClientId: '340820289997-g3bbus9bkuu5asftjfdhpeep5i26jjk1.apps.googleusercontent.com',
  apis: {
    precioysurtidos: 'PrecioYSurtidos',
    conversionunidadesdestino: 'ConversionUnidadesDestino',
    conversionunidadesorigen: 'ConversionUnidadesOrigen',
    equivalenciaArticulos: 'EquivalenciaArticulos',
    equivalenciaEstructuras: 'EquivalenciaEstructuras',
    operationCompany : 'OperationCompany',
    maestroDeArticulos: 'MaestroDeArticulos',
    clientesMixtos: 'ClientesMixtos',
    datosExtraDocSalida: 'DatosExtraDocSalida'
  },
  webServices: {
    pdfExtractor: 'https://ws.planexware.net/K360.PdfExtractor',
    pdfMapper: 'https://ws.planexware.net/K360.PdfMapper',
    QrReader: 'https://ws.planexware.net/K360.QrReader',
  },
  conciliacion: false,
  clientId: 'b9d15110-c18d-4680-8d5a-6317f43bdfdf',
  redirectUri: 'https://krikos360.planexware.net/v2/main',
  knownAuthorities: ["aidasplanexware.b2clogin.com", "aidasplanexware.onmicrosoft.com"],
  fakeDoorButton:{
    seguimientoDeEntrega: {
      visible: false,
      GA: 'Conciliacion'
    }
  },
  encuesta:{
    surveyMonkey:{
      NPS:'NPS',
      CargaWebFactura:'EncuestaCWF'
    }
  },
  urlSeguimientoEntrega: 'https://entregas.planexware.net/PXW.Logistica.SeguimientoEntregas.WEB',
  dominioSeguimientoEntrega: 'planexware.net',
  
  urlGestionTurnos: 'https://entregas.planexware.net/PXW.Logistica.GestionTurnos.WEB',
  dominioGestionTurnos: 'planexware.net'
}
